import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

import scss from './NoChartsData.module.scss';

function NoChartsData({ noDataText, height, minHeight = '300px' }) {
  const { t } = useTranslation();

  return (
    <div className={scss.wrapper} style={{ height, minHeight }}>
      <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className={scss.icon} />
      {noDataText || t('noDataForThisView')}
    </div>
  );
}

export default NoChartsData;
